export enum TenantCredentialProvider {
    Arnedo = "Arnedo",
    Cargobull = "Cargobull",
    Carrier = "Carrier",
    ESchenker = "ESchenker",
    Dachser = "Dachser",
    Backend = "Backend",
    InternalWS = "InternalWS",
    AzureAD = "AzureAD",
    Mail = "Mail",
    SendGrid = "SendGrid",
    None = "None"
}